<div
  class="-p-2 over -m-2 mb-2 flex justify-end border-b border-kb-light-gray pb-2 text-right"
>
  <div class="close-btn" tabindex="0" role="button" (click)="close()"></div>
</div>
<div
  class="mt-2 max-h-screen overflow-y-auto"
  [class.overflow-x-auto]="overflow"
>
  @if (html) {
    <div [innerHtml]="html"></div>
    <div class="mt-4 border-t border-gray-300 text-right">
      <button
        type="button"
        class="ml-4 mt-2 font-medium uppercase hover:text-kb-dark sm:mr-4"
        (click)="close()"
      >
        Zavřít
      </button>
    </div>
  }
  @if (title) {
    <h3 class="whitespace-pre-wrap text-xl font-black">
      {{ title }}
    </h3>
  }
  @if (info) {
    <p class="whitespace-pre-wrap" [innerHtml]="info"></p>
  }
  @if (component && modalInjector) {
    <ng-container
      [ngComponentOutlet]="component"
      [ngComponentOutletInjector]="modalInjector"
    />
  }
</div>
